export function UpperCaseLetter(string){
    return string.toUpperCase();
}